import React from 'react';
import classNames from 'classnames';

import css from './Notice.module.css';

const TONES = {
  info: { cls: css.info, role: 'status' },
  success: { cls: css.success, role: 'status' },
  neutral: { cls: css.neutral, role: 'status' },
  warn: { cls: css.warn, role: 'status' },
  error: { cls: css.error, role: 'alert' },
};

const svgProps = {
  className: css.icon,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '2',
  'aria-hidden': true,
};

const ToneIcon = ({ tone }) =>
  tone === 'warn' ? (
    <svg {...svgProps}>
      <path d="M12 3 2 20h20Z" />
      <path d="M12 10v4M12 17v.5" />
    </svg>
  ) : tone === 'error' ? (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6M12 16.5v.5" />
    </svg>
  ) : tone === 'success' ? (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12.5 2.5 2.5L16 9.5" />
    </svg>
  ) : (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7.5v.5" />
    </svg>
  );

/**
 * The one way a page tells someone something: green for information or success, amber
 * for something to check, red for a problem, grey for a neutral note. Say what happened
 * and what to do next; `action` (a button or link) sits at the end.
 */
const Notice = ({ tone = 'info', title, children, action, icon, role, className }) => {
  const { cls, role: toneRole } = TONES[tone] || TONES.info;
  return (
    <div className={classNames(css.root, cls, className)} role={role || toneRole}>
      {icon ? <span className={css.icon}>{icon}</span> : <ToneIcon tone={tone} />}
      <div className={css.body}>
        {title ? <p className={css.title}>{title}</p> : null}
        {children}
      </div>
      {action ? <div className={css.action}>{action}</div> : null}
    </div>
  );
};

export default Notice;
